export const getAdjustedPageNumber = (num, startPadding, sourcePages) => {
  if (num === 0) return 0;
  const adjustedNum = num - startPadding;
  if (adjustedNum < 1 || adjustedNum > sourcePages) return 0;
  return adjustedNum;
};

export const calculateSignaturePageOrder = (totalPages, sheetsPerSignature, fillLast = true) => {
  const signatures = [];
  let currentPage = 1;

  while (currentPage <= totalPages) {
    const signature = [];
    const pagesPerSignature = sheetsPerSignature * 4;
    let sigPages = Math.min(pagesPerSignature, totalPages - currentPage + 1);

    if (fillLast && currentPage + sigPages > totalPages) {
      sigPages = pagesPerSignature;
    } else {
      sigPages = Math.ceil(sigPages / 4) * 4;
    }

    const sheets = Math.ceil(sigPages / 4);
    for (let sheet = 0; sheet < sheets; sheet++) {
      const frontRight = currentPage + sigPages - sheet * 2 - 1;
      const frontLeft = currentPage + sheet * 2;
      const backLeft = currentPage + sheet * 2 + 1;
      const backRight = currentPage + sigPages - sheet * 2 - 2;

      signature.push([
        [
          frontRight > totalPages ? 0 : frontRight,
          frontLeft > totalPages ? 0 : frontLeft
        ],
        [
          backLeft > totalPages ? 0 : backLeft,
          backRight > totalPages ? 0 : backRight
        ]
      ]);
    }

    signatures.push(signature);
    currentPage += sigPages;
  }

  return signatures;
};